import { RefObject, useEffect } from 'react';

import { useDatasetDataRes } from '../api/types/types';
import { scrollGridToTop } from '../utils/managerUtils';

// Scrolls grid to top when lazy-loaded cachedQueryId changes (new data page arrived)
export const useScrollGridOnCachedQueryChange = (
  datasetData: useDatasetDataRes,
  datasetId: string | undefined,
  prevCachedQueryId: string,
  gridRef: RefObject<HTMLDivElement | any>
): void => {
  useEffect(() => {
    if (datasetData && datasetData.datasetId === datasetId) {
      if (datasetData.lazy) {
        if (
          datasetData.cachedQueryId !== prevCachedQueryId &&
          datasetData.cachedQueryId !== undefined
        ) {
          scrollGridToTop(gridRef);
        }
      }
    }
  }, [datasetData]);
};
